import { ToastrModule } from "ngx-toastr";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmationPopoverModule } from "angular-confirmation-popover";
import { ReactiveFormsModule } from "@angular/forms";
import { FormlyModule } from "@ngx-formly/core";
import { FormlyBootstrapModule } from "@ngx-formly/bootstrap";
import { ChartjsModule } from "@ctrl/ngx-chartjs";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { toastrConfig } from "./toastr.config";
import { OWL_DATE_TIME_FORMATS, OwlDateTimeModule } from "ng-pick-datetime";
import { OwlMomentDateTimeModule } from "ng-pick-datetime-moment";
import { DynamicModule } from "ng-dynamic-component";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { PipeConfig } from "../pipes/pipe-config";
import { CKEditorModule } from "ngx-ckeditor";
import { FileDropModule } from "ngx-file-drop";
import { HttpClientModule } from "@angular/common/http";
import { NgProgressModule } from "@ngx-progressbar/core";
import { NgProgressHttpModule } from "@ngx-progressbar/http";
import {
    formlyConfig,
    formlyDeclarations,
} from "../modules/formly/formly.config";
import { ColorPickerModule } from "ngx-color-picker";

export const systemThirdPartiesForRoot = [
    // Setup progress bar
    HttpClientModule,
    NgProgressModule.forRoot(),
    NgProgressHttpModule.forRoot(),
    // Setup toaster
    BrowserAnimationsModule,
    ToastrModule.forRoot(toastrConfig),
    // Setup angular bootstrap
    NgbModule.forRoot(),
    // Setup confirm popover
    ConfirmationPopoverModule.forRoot(),
    // Setup formly
    ReactiveFormsModule,
    FormlyModule.forRoot(formlyConfig),
    FormlyBootstrapModule,
    // Setup chartjs
    ChartjsModule,
    // Datetime picker
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    // Dynamic component
    DynamicModule.withComponents([]),
    // Calendar boostrap
    CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory,
    }),
    // CKeditor
    CKEditorModule,
    // File drop
    FileDropModule,
    ColorPickerModule,
];

export const importSystemThirdParties = [
    HttpClientModule,
    NgProgressModule.forRoot(),
    NgProgressHttpModule.forRoot(),
    NgbModule,
    ChartjsModule,
    ConfirmationPopoverModule,
    ReactiveFormsModule,
    FormlyModule.forChild(formlyConfig),
    FormlyBootstrapModule,
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    DynamicModule.withComponents([]),
    CalendarModule,
    CKEditorModule,
    FileDropModule,
    ColorPickerModule,
];

export const exportSystemThirdParties = [
    HttpClientModule,
    NgProgressModule,
    NgProgressHttpModule,
    NgbModule,
    ChartjsModule,
    ConfirmationPopoverModule,
    ReactiveFormsModule,
    FormlyModule,
    FormlyBootstrapModule,
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    DynamicModule,
    CalendarModule,
    CKEditorModule,
    FileDropModule,
    ColorPickerModule,
];

export const declarationsThirdParties = [...formlyDeclarations];

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_MOMENT_FORMATS = {
    parseInput: "l LT",
    fullPickerInput: PipeConfig.dateTimeFormat,
    datePickerInput: PipeConfig.dateFormat,
    timePickerInput: "LT",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
};

export const providersThirdParties = [
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
];
